export default {
  label: {
    title: 'Invite users',
    paginationTitle: 'Users with access',
    description: 'To add more than one email, separate them with commas. The added emails will appear in the list below.',
    input: 'Add one or more emails',
    users: 'Users',
  },
  hint: {
    emptyEmail: 'Please enter a valid email.',
    duplicateEmail: 'Incorrect email.',
  },
  button: {
    addUser: 'Add',
  },
  notification: {
    loadingData: 'Loading data...',
  },
};
